import StubPage from '../stub/page';

export default function MessagesPage() {
  return (
    <StubPage
      title="הודעות / פניות"
      subtitle="ניהול פניות ומסרים"
      icon="ri-message-3-line"
      description="כאן תוכל לצפות ולנהל את כל הפניות וההודעות שהתקבלו מהמשתמשים."
    />
  );
}
